import React from "react";
import PropTypes from "prop-types";

import "./Star.scss";
import { ReactComponent as StarIcon } from "assets/images/icons/star.svg";

const SIZES = {
  sm: {
    width: 12,
    height: 11,
  },
  md: {
    width: 14,
    height: 13,
  },
  lg: {
    width: 16,
    height: 15,
  },
};

function Star({ name, color, handleChange, count, hover, size = "lg" }) {
  return (
    <span className={`${!hover ? "" : "fastar-div"}`}>
      {[...Array(5)].map((rating, index) => (
        <StarIcon
          key={index}
          {...(size && SIZES[size])}
          {...(index < count ? { fill: color, stroke: color } : { fill: "white", stroke: "black" })}
          onClick={() => handleChange && handleChange(name, index + 1)}
        />
      ))}
    </span>
  );
}
Star.propTypes = {
  name: PropTypes.string,
  handleChange: PropTypes.func,
  color: PropTypes.string,
  count: PropTypes.number,
  hover: PropTypes?.bool,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};
Star.defaultProps = {
  name: "",
  handleChange: null,
  color: "#FDB833",
  count: 0,
  hover: false,
  size: "lg",
};
export default Star;
